(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["viorra-national-day-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('viorra-national-day');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const key = `viorra-national-day-2026:${dialog.dataset.locale}`;
    const preview = dialog.dataset.preview === 'true' && new URLSearchParams(location.search).get('viorra_offer') === 'preview';
    const expired = () => Date.now() >= Date.parse(dialog.dataset.end);
    let seen = false;
    try { seen = sessionStorage.getItem(key) === 'seen'; } catch {}
    if (expired() || (seen && !preview)) return;
    let previousFocus;
    let previousOverflow;
    let expiryTimer;
    const markSeen = () => { try { sessionStorage.setItem(key, 'seen'); } catch {} };
    const close = () => { markSeen(); if (dialog.open) dialog.close(); };
    dialog.querySelector('.vnd__close').addEventListener('click', close);
    dialog.querySelector('.vnd__shop').addEventListener('click', close);
    dialog.addEventListener('cancel', () => markSeen());
    dialog.addEventListener('click', (event) => { if (event.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); });
    dialog.addEventListener('close', () => { clearTimeout(expiryTimer); document.documentElement.style.overflow = previousOverflow; if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({preventScroll:true}); });
    const open = () => {
      if (expired() || dialog.open || !dialog.isConnected) return;
      if (document.querySelector('dialog[open]')) { setTimeout(open, 1500); return; }
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      dialog.querySelector('.vnd__title').focus({preventScroll:true});
      document.documentElement.style.overflow = 'hidden';
      markSeen();
      expiryTimer = setTimeout(close, Math.min(Date.parse(dialog.dataset.end) - Date.now(), 2147483647));
    };
    setTimeout(open, 2000);
  })();
  } catch(e) { console.error(e); }
})();

})();
